const updateHasPaid = (user, hasPaid, setUser) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  return fetch(`${backendUrl}/api/users/${user.meta._id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ hasPaid }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error updating user");
      }
      return response.json();
    })
    .then((data) => {
      console.log("User updated:", data.user);
      sessionStorage.setItem(
        "user",
        JSON.stringify({ ...user, meta: { ...data.user } }),
      );
      setUser({ ...user, meta: { ...data.user } });
      return data.user;
    })
    .catch((error) => {
      console.error("Error updating user:", error);
      throw error;
    });
};
export { updateHasPaid };
